<div class="workSpace">
  <!-- Titulo -->
  <div class="w3-container w3-container-template headersTab">
   <!--Titulo de modulo y subtitulo-->
    <div class="w3-caja-menu padreizquierda">
      <div class="w3-row hijoizquierda centradoVertical w3-quarter">
        <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal"> <b> {{ 'menu.'+dataService.moduleSelect | translate }} </b></span>
        <span class="w3-text-deep-orange">&bull;</span>
        <span class="w3-text-orange w3-margin-left-filter w3-subtituloPrincipal"> {{ 'menu.'+dataService.subModuleSelect | translate }} </span>
      </div>
      <!-- Filtros -->
        <div class="w3-rest">
            <div class="w3-noventa2 w3-row">
                <!-- Institución Seleccionada -->
                <div class="w3-third padreizquierda">
                    <div class="w3-row w3-center centradoVertical institucion" (click)="selectInst()" style="cursor: pointer; height: 100%; padding-top: 20px;" >
                        <span>{{instSelecc.alias || 'Seleccionar Institución'}}</span>
                    </div>
                </div>
                <!-- Filtro de Sucursales -->
                <div class="w3-third padreizquierda">
                    <app-filters [name]="'filtros.sucursales' | translate" [array]="dataSucursales"
                        [typeFilter]="Filters.SUCURSALES" [click]="false" [consolidado]="consolidado"
                        (eventClick)="sucursalChange($event)">
                    </app-filters>
                </div>
            </div>
    </div>
  </div>
  <!-- TABLERO -->
  <div class="workSpaceTab">
    <!-- Zona superior: tabla de cuentas -->
    <div class="zona1 w3-row">    
      <div class="w3-white" style="padding: auto;">
        <!--Encabezado del primer cuadrante-->
      <div class="w3-row w3-write w3-header-cuadrante" style="height: 6vh;">
        <!--Titulo de la primer gráfica-->
        <div class="w3-thirty hijoIzquierdaTitle w3-titulo-contenidomenu">
          <div class="hijoizquierdaTitle">
            <span class="w3-margin-left-contenido">{{'proyFinanciera.proyecciones.titTabla' | translate}}</span>
            <span class="w3-punto-subtitulo w3-margin-left-filter">&bull;</span>
            <span class=" w3-margin-left-filter w3-subtitulo">{{periodoSelec.name}}</span>
          </div>
        </div>
        <div class="w3-quarter w3-row" style="height: 6vh; display: flex; justify-content: end; align-items: center;"> 
          <label for="sinSaldo" style="margin-right: 15px;">Sin saldo </label>
          <input type="checkbox" [checked]="sinSaldo" (change)="filtroSinSaldo()" />
        </div>
        <!--Menu tabla principal-->
        <div class="w3-rest w3-right-align_rest">
          <div class="w3-right hijoderechaTitle">
            <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}" [matMenuTriggerFor]="menuP2">more_vert</mat-icon>
          </div>
          <mat-menu #menuP2="matMenu" xPosition="before">
            <button mat-menu-item (click)="guardarConfiguracion()">
              <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">image</mat-icon>
              <span>{{'proyFinanciera.proyecciones.guardarConfig' | translate}}</span>
            </button>
          </mat-menu>
        </div>
      </div>
      <!-- TABLA CUENTAS -->
      <div class="w3-scroll" style="margin-bottom: 1%; height: 41vh;">
        <table class="w3-table">
          <thead>
            <tr class="w3-table-titleLow w3-center">
              <th class="w3-border-right-balance marginsH stikyColum" style="min-width: 110px;">{{'proyFinanciera.proyecciones.tit1' | translate}}</th>
              <th class="w3-border-right-balance marginsH stikyColum" style="min-width: 220px;">{{'proyFinanciera.proyecciones.tit2' | translate}}</th>
              <th class="w3-border-right-balance marginsH stikyColum" style="min-width: 140px;">{{'proyFinanciera.proyecciones.tit3' | translate}}</th>
              <th class="w3-border-right-balance marginsH stikyColum" style="min-width: 200px;">{{'proyFinanciera.proyecciones.tit4' | translate}}</th>
              <th class="w3-border-right-balance marginsH stikyColum" style="min-width: 120px;">{{'proyFinanciera.proyecciones.tit5' | translate}}</th>
            </tr>
          </thead>
          <tbody>
            @if(cuentas.length > 0){
              @for (cuenta of cuentas; track cuenta.codigo) {
                <tr class="w3-table-trtd">
                  <td class="borderAllLow marginsH alinRight" (click)="cambiarImagen(cuenta)" style="cursor: pointer;" matTooltip="{{'proyFinanciera.proyecciones.selecCuenta' | translate}}">
                    {{ cuenta.codigo }}
                  </td>
                  <td class="borderAllLow marginsH alinLeft" (click)="cambiarImagen(cuenta)" style="cursor: pointer;" matTooltip="{{'proyFinanciera.proyecciones.selecCuenta' | translate}}">
                    {{ cuenta.nombre }}
                  </td>
                  <td class="borderAllLow marginsH alinRight">
                    {{ cuenta.saldo }}
                  </td>
                  <td class="borderAllLow marginsH alinLeft">
                    <select class="w3-select" style="color: #6b596b;">
                      @for (metodo of metodosProyeccion; track metodo.valor) {
                        <option [value]="metodo.valor" [selected]="metodo.valor === cuenta.metodoProyeccion">
                          {{ metodo.label }}
                        </option>
                      }
                    </select>
                  </td>
                  <td class="borderAllLow marginsH w3-center" >
                    <div style="display: flex; justify-content: center; align-items: center;">
                      <input type="checkbox" [checked]="cuenta.valido" (change)="cuenta.valido = !cuenta.valido" />
                    </div>
                  </td>
                </tr>
              }  
            }@else{
              <div class="preview-background">
                <div class="page">
                  <ngx-skeleton-loader count="8" [theme]="{ 
                    'border-radius': '10px',
                    height: '2vh',
                    width: '60vw',
                  }" />
                </div>
              </div>
            }            
          </tbody>
        </table>  
    </div>
      

    <!-- Zona inferior: imagen con gráfica -->
    <div class="zona2 w3-row">
      <div class="w3-row w3-write w3-header-cuadrante">
        <!--Titulo de la primer gráfica-->
        <div class="w3-twothird hijoIzquierdaTitle w3-titulo-contenidomenu">
          <div class="hijoizquierdaTitle">
            <span class="w3-margin-left-contenido">{{'proyFinanciera.proyecciones.proyeccion' | translate}} | {{cuentaSelec?.nombre}}</span>
            <span class="w3-punto-subtitulo w3-margin-left-filter">&bull;</span>
            <span class=" w3-margin-left-filter w3-subtitulo">{{periodoSelec.name}}</span>
          </div>
        </div>
      </div>
      <div class="grafica-contenedor w3-row w3-center w3-white">
        <img
          [src]="graficaUrl"
          alt="Gráfica de proyecciones financieras"
          class="grafica-imagen"
        />
      </div>
    </div>
  </div>
</div>

<app-modal [isOpen]="modalOpen" (close)="closeModal()">
  <div modal-header>
    {{'proyFinanciera.proyecciones.escenario' | translate}}
  </div>
  <div modal-body>
    <div class="w3-row w3-center" style="margin: 1vh;">
      <form [formGroup]="formEscenario" (ngSubmit)="guardarEscenario()" id="formIndicador">      
        <div class="w3-row campoForm">
          <div class="w3-row w3-quarter_e alinLeft marginsH" style="margin-top: 2%; width: 20%!important;">{{'proyFinanciera.proyecciones.campo1' | translate}}</div>
          <div class="w3-rest alinLeft">
            <mat-form-field appearance="outline" color="warn" class="field-input" style="width: 30vw; margin-right: 5vw;">
              <input matInput placeholder="Nombre" formControlName="nombre">
            </mat-form-field>
          </div>
        </div>
        <div class="w3-row campoForm">
          <div class="w3-row w3-quarter_e alinLeft marginsH" style="margin-top: 2%; width: 20%!important;">{{'proyFinanciera.proyecciones.campo2' | translate}}</div>
          <div class="w3-rest alinLeft">
            <mat-form-field appearance="outline" color="warn" class="field-input" style="width: 30vw; margin-right: 5vw;">
              <input matInput placeholder="Tipo" formControlName="tipo">
            </mat-form-field>
          </div>
        </div>
        <div class="w3-row campoForm">
          <div class="w3-row w3-quarter_e alinLeft marginsH" style="margin-top: 2%; width: 20%!important;">{{'proyFinanciera.proyecciones.campo3' | translate}}</div>
          <div class="w3-rest alinLeft">
            <div class="w3-thirty" style="margin-right: 5vw;">
              <mat-form-field appearance="outline" color="warn" class="field-input" style="width: 12vw; margin-right: 5vw;">
                <input matInput [matDatepicker]="pickerInicio" formControlName="fechaIni" [min]="formEscenario.get('fechaFin')?.value" readonly
                placeholder="Fecha inicio">
                <mat-datepicker-toggle matSuffix [for]="pickerInicio"></mat-datepicker-toggle>
                <mat-datepicker #pickerInicio startView="year"
                                (monthSelected)="setFecha($event, pickerInicio, 'fechaIni')"
                                panelClass="month-picker">
                </mat-datepicker>
              </mat-form-field>
            </div>            
            <div class="w3-thirty">
              <mat-form-field appearance="outline" color="warn" class="field-input" style="width: 12vw; margin-right: 5vw;">
                <input matInput [matDatepicker]="pickerFin" formControlName="fechaFin" [min]="formEscenario.get('fechaIni')?.value" readonly
                placeholder="Fecha fin">
                <mat-datepicker-toggle matSuffix [for]="pickerFin"></mat-datepicker-toggle>
                <mat-datepicker #pickerFin startView="year"
                                (monthSelected)="setFecha($event, pickerFin, 'fechaFin')"
                                panelClass="month-picker">
                </mat-datepicker>
              </mat-form-field>
            </div>            
          </div>
        </div>
        <div class="w3-row campoForm">
          <div class="w3-row w3-quarter_e alinLeft marginsH" style="margin-top: 2%; width: 20%!important;">{{'proyFinanciera.proyecciones.campo4' | translate}}</div>
          <div class="w3-rest alinLeft">
            <mat-form-field appearance="outline" color="warn" class="field-textArea" style="width: 30vw; margin-right: 5vw;">
              <textarea matInput placeholder="Descripción" style="resize: none;" formControlName="descripcion"></textarea>
            </mat-form-field>
          </div>
        </div>  
        <div class="w3-row campoForm">
          <div class="w3-row w3-quarter_e alinLeft marginsH" style="margin-top: 2%; width: 20%!important;">{{'proyFinanciera.proyecciones.campo5' | translate}}</div>
          <div class="w3-rest alinLeft">
            <mat-form-field appearance="outline" color="warn" class="field-input" style="width: 12vw; margin-right: 5vw;">
              <input matInput [matDatepicker]="pickerEla" formControlName="fechaElaboracion"
              placeholder="dd/mm/yyyy">
              <mat-datepicker-toggle matSuffix [for]="pickerEla"></mat-datepicker-toggle>
              <mat-datepicker #pickerEla startView="month"
                              (monthSelected)="setFecha($event, pickerEla, 'fechaElaboracion')"
                              panelClass="month-picker">
              </mat-datepicker>
            </mat-form-field>     
          </div> 
        </div>      
        <!-- Boton guardar -->
        <div class="w3-row w3-center" style="margin-top: 4vh;">
          <button mat-flat-button color="success" style="height: 5vh; width: 30%;" [disabled]="formEscenario.invalid" 
          [ngClass]="{'w3-disabled': formEscenario.invalid}">{{'proyFinanciera.proyecciones.guardarEsce' | translate}}</button>
        </div>
      </form>
    </div>
  </div>
  <div modal-footer>

  </div>
</app-modal>
